import axios from './httpClient';
import { getAccessToken } from './accessToken';



export async function postResumenDeCuenta(instance, accounts, userID, company) {
  if (company === 'CORTE') {
    company = null } else {
    company = 'UNI';
    }
  console.log(company);
  const accessToken = await getAccessToken(instance, accounts);
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
  console.log(company)
  let url = `${process.env.REACT_APP_API_URL}/customers/${userID}/reports/balance`;

  if (company) {
    url += `?company=${company}`;
  }
  return axios
    .get(url, config)

    .then((response) => {
      console.log('soy el response', response);
      return response.data;
    });
}
//
export async function postResumenDeCuentaHistorico(instance, accounts, userID, company) {
  if (company === 'CORTE') {
    company = null } else {
    company = 'UNI';
    }
  console.log(company);
  const accessToken = await getAccessToken(instance, accounts);
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
  console.log(company)
  let url = `${process.env.REACT_APP_API_URL}/customers/${userID}/reports/historicalBalance`;

  if (company) {
    url += `?company=${company}`;
  }
  return axios
    .get(url, config)

    .then((response) => {
      console.log('soy el response', response);
      return response.data;
    });
}
